import React from 'react';
import { ArrowRight, X, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';

export default function AlbumGallery({ media, albums, selectedAlbum, setSelectedAlbum, lightboxIndex, setLightboxIndex, isAdmin, handleDeleteMedia, getMediaUrl }) {
  if (selectedAlbum) {
    const albumPhotos = media.filter(m => m.album === selectedAlbum);
    return (
      <div data-testid="album-detail">
        <div className="flex items-center gap-4 mb-6">
          <Button variant="ghost" onClick={() => { setSelectedAlbum(null); setLightboxIndex(-1); }} className="text-fuchsia-600 hover:text-fuchsia-700" data-testid="back-to-albums">
            <ArrowRight className="h-4 w-4 rotate-180 mr-2" />Retour aux albums
          </Button>
          <h3 className="text-2xl font-bold text-zinc-900">{selectedAlbum}</h3>
          <span className="text-sm text-zinc-500">({albumPhotos.length} photos)</span>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {albumPhotos.map((item, index) => (
            <div key={item.id} className="relative aspect-square overflow-hidden rounded-lg cursor-pointer group bg-zinc-100" onClick={() => setLightboxIndex(index)} data-testid={`album-photo-${index}`}>
              <img src={getMediaUrl(item.url)} alt={item.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300" />
              {isAdmin && (
                <Button onClick={(e) => { e.stopPropagation(); handleDeleteMedia(item.id); }} variant="destructive" size="icon" className="absolute top-2 right-2 h-7 w-7 opacity-0 group-hover:opacity-100 transition-opacity">
                  <Trash2 className="h-3 w-3" />
                </Button>
              )}
            </div>
          ))}
        </div>

        {lightboxIndex >= 0 && (() => {
          const current = albumPhotos[lightboxIndex];
          if (!current) return null;
          return (
            <div className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center" onClick={() => setLightboxIndex(-1)} data-testid="lightbox">
              <button className="absolute top-6 right-6 text-white/80 hover:text-white z-50" onClick={() => setLightboxIndex(-1)} data-testid="lightbox-close"><X className="h-8 w-8" /></button>
              <button className="absolute left-4 top-1/2 -translate-y-1/2 text-white/60 hover:text-white p-2" onClick={(e) => { e.stopPropagation(); setLightboxIndex(Math.max(0, lightboxIndex - 1)); }} data-testid="lightbox-prev"><ArrowRight className="h-10 w-10 rotate-180" /></button>
              <img src={getMediaUrl(current.url)} alt={current.title} className="max-h-[85vh] max-w-[90vw] object-contain" onClick={(e) => e.stopPropagation()} />
              <button className="absolute right-4 top-1/2 -translate-y-1/2 text-white/60 hover:text-white p-2" onClick={(e) => { e.stopPropagation(); setLightboxIndex(Math.min(albumPhotos.length - 1, lightboxIndex + 1)); }} data-testid="lightbox-next"><ArrowRight className="h-10 w-10" /></button>
              <div className="absolute bottom-6 text-white/70 text-sm">{lightboxIndex + 1} / {albumPhotos.length}</div>
            </div>
          );
        })()}
      </div>
    );
  }

  return (
    <div>
      {albums.length > 0 && (
        <div className="mb-8">
          <h3 className="text-xl font-bold text-zinc-900 mb-4">Albums</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {albums.map((album, index) => (
              <div key={album.name} className="overflow-hidden group border-0 shadow-lg cursor-pointer hover:shadow-xl transition-shadow rounded-lg" onClick={() => setSelectedAlbum(album.name)} data-testid={`album-card-${index}`}>
                <div className="relative aspect-video overflow-hidden bg-zinc-100">
                  {album.cover_url && <img src={getMediaUrl(album.cover_url)} alt={album.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  <div className="absolute bottom-4 left-4 text-white">
                    <h4 className="text-lg font-bold">{album.name}</h4>
                    <p className="text-sm text-white/80">{album.count} photos</p>
                    {album.credit && <p className="text-xs text-white/60 italic mt-0.5">{album.credit}</p>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
